import { render, staticRenderFns } from "./JoinRequests.vue?vue&type=template&id=34e9050e"
import script from "./JoinRequests.vue?vue&type=script&lang=js"
export * from "./JoinRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports